import axios, { AxiosError } from 'axios'
import { axiosConfiguration } from './lexonHttp/headers'
import { useAuthStore } from '@/stores/auth/useAuthStore'
import { AUTH_ERRORS } from './lexonHttp/errors'
import { onUnauthorizedRequest } from './lexonHttp/tokenRefresh'
import { noBearerTokenURL } from '@/router/routes/urlRoutes'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'

export const lexonHttp = axios.create(axiosConfiguration)

lexonHttp.interceptors.request.use(
  (config: any) => {
    if (!noBearerTokenURL.some((url) => config.url?.includes(url))) {
      // insertamos token en el header
      const authStore = useAuthStore()
      config.headers.Authorization = `Bearer ${authStore.accessToken}`

      // guardamos la peticion en el store por si se necesita cancelar
      config.cancelToken = saveRequest(config.url)
    }
    return config
  },
  (error: Error) => {
    return Promise.reject(error)
  }
)

lexonHttp.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.code === 'ERR_CANCELED') {
      // Si la peticion ha sido cancelada, no hacemos nada
      return
    }

    if (!AUTH_ERRORS.hasOwnProperty((error as any).response?.status)) {
      return Promise.reject(error)
    }

    const { response, config } = error as any
    if (AUTH_ERRORS.hasOwnProperty(response.status) && !config.url.includes('login')) {
      return onUnauthorizedRequest(error)
    }

    return Promise.reject(error)
  }
)

function saveRequest(url: string) {
  if (['menus/site', 'v2/user/tool', 'v2/logout', 'v2/refresh-session', 'menus/configuration'].includes(url)) return
  const source = axios.CancelToken.source()
  store.dispatch(`${ModuleNamespaces.AUTH}/addPendingRequest`, source)
  return source.token
}
